define('common/views/notice_view_mdnotice',['require','exports','module','base/view','lodash','jquery','backbone','i18n','env','services/auth','mdnotice','common/models/appstate'],function (require, exports, module) {
  'use strict';

  var View = require('base/view'),
    _ = require('lodash'),
    $ = require('jquery'),
    Backbone = require('backbone'),
    i18n = require('i18n'),
    Config = require('env'),
    Auth = require('services/auth'),
    authInfo = Auth.getAuthInfo(),
    mdNotice = require('mdnotice'),
    AppState = require('common/models/appstate');

  var Header = Backbone.View.extend({
    userLang: i18n.lng(),
    initialize: function () {
      this.userLang = i18n.lng();
      if (AppState._companyInfo) {
        this.listenTo(AppState._companyInfo, 'all', this.render);
      }
    },

    render: function () {
      var self = this;
      mdNotice.init({
        el: '#noticeContainer',
        url: Config.signupBackendUrl + '/notice/landings',
        cors: true,
        userData: {
          user: authInfo.getUserName(),
          userType: AppState.getRolId(),
          product: 'landings',
          name: authInfo.getUserName(),
          lang: this.userLang,
        },
      });
      return this;
    },
  });

  module.exports = Header;
});

